/* eslint-disable import/no-anonymous-default-export */
export default {
  loadingplaces: {
    list: [],
    loading: false,
    current: null,
    error: null,
    fetching: true,
  },
};
